/// <reference path="../wpt.ts" />
var WPTNamespace;
(function (WPTNamespace) {
    var DocActions;
    (function (DocActions) {
        const LOG_CATEGORY = "WPT.DocumentActions.ReviseDocument";
        class DocActionReviseDocument extends DocActions.DocActionBaseClass {
            constructor(core, name) {
                super(core, name);
                this._fileInput = null;
                this._okButton = null;
                this._filenamePara = null;
                this._currentRequest = null;
                this._currentModalSession = null;
                this._storeHtml = (htmlData) => {
                    this._log.info("DocActionReviseDocument._storeHtml()");
                    DocActionReviseDocument.Html = htmlData;
                    this._readyToExecute = true;
                    if (this._pendingRequest)
                        this.execute(this._pendingRequest);
                };
                this._okClicked = (event) => {
                    this._log.info("DocActionReviseDocument._okClicked()");
                    let file = this._fileInput.files[0];
                    let requestUpload = {
                        RevisionOf: this._currentRequest.DocHandle,
                        Date: this._core.Functions.dateNumberToTransportFormat(Date.now()),
                        PreventAddToWorkflow: false,
                        FileType: file.name.split('.').pop().toUpperCase()
                    };
                    let request = JSON.stringify(requestUpload);
                    if (this._log.isTraceEnabled()) {
                        this._log.trace(`Request: ${request}`);
                    }
                    let formData = new FormData();
                    formData.append("request", request);
                    formData.append('file', file);
                    let headers = {
                        "Content-Type": "multipart/form-data"
                    };
                    this._core.Loader.genericServiceCallWithData('/Upload.svc/rest/ReviseDocumentByStream', formData, this._finishedUpload, headers, this._errorCallback, this._failCallback);
                    this._core.hideModal(this._currentModalSession);
                    this._currentModalSession = null;
                };
                this._fileSelected = (event) => {
                    this._log.info("DocActionReviseDocument._fileSelected()");
                    if (!this._fileInput.files) {
                        this._core.hideModal(this._currentModalSession);
                        this._currentModalSession = null;
                        return;
                    }
                    this._filenamePara.innerText = this._fileInput.files[0].name;
                    this._okButton.disabled = false;
                };
                this._finishedUpload = (response) => {
                    this._log.info("DocActionReviseDocument._finishedUpload()");
                    if (response.hasOwnProperty('Documents') && (response.Documents != null) && (response.Documents.length > 0)) {
                        let navEvent = new WPTNamespace.Navigation.ActivationContext(null, WPTNamespace.Navigation.LayoutActivationType.DOCUMENT_REVISED);
                        navEvent.ActivationID = response.Documents[0].ItemNum;
                        navEvent.PrimaryContext = response.Documents[0];
                        navEvent.Layout = this._core.Navigation.Details.getActiveLayoutName();
                        this._core.Navigation.Details.requestActivation(navEvent);
                    }
                    else {
                        console.warn('Document revision request returned success, but passed no document back.');
                    }
                };
                this._failCallback = (json) => {
                    this._log.info("DocActionReviseDocument._failCallback()");
                    let response = json;
                    console.warn(response.Connection.Message);
                    this._core.Helper.presentWarningModal(response.Connection.Message);
                };
                this._errorCallback = (url, status, message) => {
                    this._log.info("DocActionReviseDocument._errorCallback()");
                    console.warn(message);
                    this._core.Helper.presentWarningModal(message);
                };
                this._doctypesLoaded = () => {
                    this._log.info("DocActionReviseDocument._doctypesLoaded()");
                    // do nothing here, callback is used to force loading of upload document types if needed
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("DocActionReviseDocument::constructor");
                this._label = this._core.Locale.getTranslation("STR_WPT_REVISE_DOC");
                this._core.OBHelper.LoadUploadDocumentTypes(this._doctypesLoaded);
                if (!DocActionReviseDocument.Html) {
                    core.Loader.getVersionedHTML('widgets/documentactions/revisedocument.html', this._storeHtml, this._core.Helper.missingHtmlErrorCallback);
                }
                else {
                    this._readyToExecute = true;
                    if (this._pendingRequest)
                        this.execute(this._pendingRequest);
                }
            }
            actionAllowed(request) {
                this._log.info("DocActionReviseDocument.actionAllowed()");
                if (request.hasOwnProperty('DocumentType') && request.DocumentType) {
                    if (request.DocumentType.Name in this._core.OBHelper.UploadDocumentTypeMap) {
                        let docType = this._core.OBHelper.UploadDocumentTypeMap[request.DocumentType.Name];
                        return docType.Privileges.CreateDeleteRevisions && docType.AllowRevisions;
                    }
                }
                return false;
            }
            execute(request) {
                this._log.info("DocActionReviseDocument.execute()");
                let modalSession = 'revise-doc-modal-' + performance.now();
                if (this._log.isTraceEnabled()) {
                    this._log.trace("created modal session: " + modalSession);
                }
                let modal = this._core.requestModal(WPTNamespace.ModalType.FIRST, modalSession);
                if (modal !== null && modal !== undefined) {
                    this._currentModalSession = modalSession;
                    this._currentRequest = request;
                    modal.DIV.innerHTML = DocActionReviseDocument.Html;
                    this._fileInput = modal.DIV.querySelector('#revisedaFileInput');
                    this._okButton = modal.DIV.querySelector('#revisedaOK');
                    this._filenamePara = modal.DIV.querySelector('#revisedaFileNamePara');
                    let cancelTranslation = this._core.Locale.getTranslation('STR_WPT_CANCEL');
                    modal.DIV.querySelector('#revisedaCancelLabel').innerHTML = cancelTranslation;
                    let closeIcon = modal.DIV.querySelector('#closeIcon');
                    closeIcon.setAttribute('title', cancelTranslation);
                    closeIcon.setAttribute('aria-label', cancelTranslation);
                    this._core.Helper.setElementTranslation(modal.DIV.querySelector('#revisedaDialogHeading'), 'STR_WPT_REVISE_DOC');
                    this._core.Helper.setElementTranslation(this._okButton.querySelector('#revisedaOKLabel'), 'STR_WPT_LABEL_OK');
                    this._core.Helper.setElementTranslation(modal.DIV.querySelector('#revisedaInfoPara'), 'STR_WPT_REVISING_CONFIRM');
                    this._fileInput.accept = this._core.Config.getApplicationConfig().DefaultAcceptFilter;
                    this._fileInput.addEventListener('change', this._fileSelected);
                    this._okButton.addEventListener('click', this._okClicked);
                    this._core.showModal(this._currentModalSession);
                    // Set value to ensure clicks are recorded against same file being chosed twice
                    this._fileInput.value = null;
                    this._fileInput.click();
                }
                else {
                    console.error("unable to show revise document modal, modal placeholder is already used");
                }
            }
        }
        DocActionReviseDocument.Html = null;
        DocActions.DocActionReviseDocument = DocActionReviseDocument;
    })(DocActions = WPTNamespace.DocActions || (WPTNamespace.DocActions = {}));
})(WPTNamespace || (WPTNamespace = {}));
